import React from 'react'
import { object } from 'prop-types'

function reviewSentence (props) {
  const { productData, location, pageData } = props
  const {
    productReviews: { reviewsData }
  } = productData
  const { reviews = [], meta = {} } = reviewsData || {}

  if (!reviews || reviews.length === 0) {
    return (
      <p>
        Aktuell liegen uns leider noch nicht ausreichend Kundenbewertungen vor.
      </p>
    )
  }

  return (
    <div
      className='reviewsContainer'
      location={location.name}
      type={`${pageData.productClass}`}
    >
      <div>
        Unsere Kunden bewerteten
        <span> {productData.name} </span>durchschnittlich mit
        <span>
          <span> {meta.averageRating} </span> von 10
          Punkten (<strong>{meta.count} </strong>
          <a
            className='hover'
            title={`${productData.name} Kundenbewertungen`}
            href={`/${pageData.pageName}/kundenbewertungen.html`}
          >
            Kundenbewertungen
          </a>
          ).
        </span>
      </div>
    </div>
  )
}

reviewSentence.propTypes = {
  productData: object.isRequired,
  location: object.isRequired,
  pageData: object.isRequired
}

export default reviewSentence



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/reviewSentence.jsx